import {
  GraphQLObjectType,
  GraphQLString,
  GraphQLNonNull,
  GraphQLBoolean,
  GraphQLInt,
  GraphQLID,
  GraphQLList
} from 'graphql';

import UserType from './user.gql.js';

const channelCardType = new GraphQLObjectType({
  name: 'ChannelCardType',
  fields: () => ({
    id: {
      type: new GraphQLNonNull(GraphQLID),
      resolve: item => item.id
    },
    pid: {
      type: GraphQLString,
      resolve: item => item.pid
    },
    approved: {
      type: GraphQLBoolean,
      resolve: item => item.approved
    },
    name: {
      type: GraphQLString,
      resolve: item => item.name
    },
    duration: {
      type: GraphQLInt,
      resolve: item => item.duration
    },
    likes: {
      type: new GraphQLList(UserType),
      resolve: item => item.likes
    },
    isLiked: {
      type: GraphQLBoolean,
      resolve: item => item.isLiked
    },
    likesCount: {
      type: GraphQLInt,
      resolve: item => item.likesCount
    },
    publishedBy: {
      type: UserType,
      resolve: item => item.publishedBy
    },
    channelCardType: {
      type: GraphQLString,
      resolve: item => item.channelCardType
    },
    mobileThumbUrlZoom: {
      type: GraphQLString,
      resolve: item => item.mobileThumbUrlZoom
    },
    mobileThumbUrl: {
      type: GraphQLString,
      resolve: item => item.mobileThumbUrl
    },
    url: {
      type: GraphQLString,
      resolve: item => item.url
    },
    narrationUrl: {
      type: GraphQLString,
      resolve: item => item.narrationUrl
    },
    htmlContent: {
      type: GraphQLString,
      resolve: item => item.htmlContent
    },
    updatedAt: {
      type: GraphQLString,
      resolve: item => item.updatedAt
    }
  })
});

window[channelCardType.name + 'GQLType'] = channelCardType;

export default channelCardType;
